import React from "react";
import InterestCSS from "../../../style/helperCSS/Interest.module.css";

const InterestCard = (props) => {
  return (
    <div className={`col-sm-6 col-lg-4 col-12 ${InterestCSS.card}`}>
      <div className={`${InterestCSS.card_main_div}`}>
        <div className={`${InterestCSS.card_item}`}>
          <img src={props.img} alt="icon" />
          <h4>{props.title}</h4>
        </div>
      </div>
    </div>
  );
};

export default InterestCard;
